// import React from 'react';
// import { useTranslation } from 'react-i18next';

// const RemovalPage = ({ onButtonClick, onBack }) => {
//   const { t } = useTranslation();
  
//   const removalServices = [
//     { name: t('removalPage.services.body2mm'), price: t('removalPage.prices.body2mm') },
//     { name: t('removalPage.services.face2mm'), price: t('removalPage.prices.face2mm') },
//     { name: t('removalPage.services.body5mm'), price: t('removalPage.prices.body5mm') },
//     { name: t('removalPage.services.face5mm'), price: t('removalPage.prices.face5mm') },
//     { name: t('removalPage.services.complexity1'), price: t('removalPage.prices.complexity1') },
//     { name: t('removalPage.services.complexity2'), price: t('removalPage.prices.complexity2') },
//     { name: t('removalPage.services.complexity3'), price: t('removalPage.prices.complexity3') },
//     { name: t('removalPage.services.over10mm1'), price: t('removalPage.prices.over10mm1') },
//     { name: t('removalPage.services.over10mm2'), price: t('removalPage.prices.over10mm2') },
//     { name: t('removalPage.services.over10mm3'), price: t('removalPage.prices.over10mm3') },
//     { name: t('removalPage.services.over10mm4'), price: t('removalPage.prices.over10mm4') },
//     { name: t('removalPage.services.papilloma'), price: t('removalPage.prices.papilloma') },
//     { name: t('removalPage.services.wartsFace'), price: t('removalPage.prices.wartsFace') },
//     { name: t('removalPage.services.wartsPlantar'), price: t('removalPage.prices.wartsPlantar') },
//     { name: t('removalPage.services.condylomas'), price: t('removalPage.prices.condylomas') },
//     { name: t('removalPage.services.papillomas10'), price: t('removalPage.prices.papillomas10') },
//     { name: t('removalPage.services.papillomas20'), price: t('removalPage.prices.papillomas20') },
//     { name: t('removalPage.services.cryotherapy05'), price: t('removalPage.prices.cryotherapy05') },
//     { name: t('removalPage.services.cryotherapy06'), price: t('removalPage.prices.cryotherapy06') },
//     { name: t('removalPage.services.cryotherapy10'), price: t('removalPage.prices.cryotherapy10') },
//     { name: t('removalPage.services.cryotherapy19'), price: t('removalPage.prices.cryotherapy19') },
//     { name: t('removalPage.services.anesthesia'), price: t('removalPage.prices.anesthesia') },
//     { name: t('removalPage.services.back'), price: '' }
//   ];

//   const handleServiceClick = (serviceName, servicePrice) => {
//     if (serviceName === t('removalPage.services.back')) {
//       onBack();
//     } else {
//       onButtonClick(serviceName, servicePrice);
//     }
//   };

//   return (
//     <>
//       <header className="header">
//         <div className="clinic-logo">
//           <div className="logo-icon">🔬</div>
//           <h1>{t('removalPage.title')}</h1>
//         </div>
        
//         <div className="user-greeting">
//           <p>{t('removalPage.subtitle')}</p>
//         </div>
//       </header>

//       <main className="main-content">
//         <div className="welcome-section">
//           <h2>{t('removalPage.welcome')}</h2>
//           <p className="subtitle">{t('removalPage.chooseProcedure')}</p>
//         </div>

//         <div className="buttons-grid">
//           {removalServices.map((service, index) => (
//             <button 
//               key={index}
//               className={`service-btn ${service.name === t('removalPage.services.back') ? 'back-btn' : ''}`}
//               onClick={() => handleServiceClick(service.name, service.price)}
//             >
//               <div className="service-info-full">
//                 <span className="service-name-full">{service.name}</span>
//                 {service.price && <span className="service-price">{service.price}</span>}
//               </div>
//             </button>
//           ))}
//         </div>
//       </main>

//       <footer className="footer">
//         <p>{t('removalPage.footer.main')}</p>
//         <p className="footer-info">{t('removalPage.footer.info')}</p>
//       </footer>
//     </>
//   );
// };

// export default RemovalPage;



import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const RemovalPage = ({ onButtonClick, onBack }) => {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState([]);
  
  const removalServices = [
    { id: 1, name: t('removalPage.services.body2mm'), price: t('removalPage.prices.body2mm') },
    { id: 2, name: t('removalPage.services.face2mm'), price: t('removalPage.prices.face2mm') },
    { id: 3, name: t('removalPage.services.body5mm'), price: t('removalPage.prices.body5mm') },
    { id: 4, name: t('removalPage.services.face5mm'), price: t('removalPage.prices.face5mm') },
    { id: 5, name: t('removalPage.services.complexity1'), price: t('removalPage.prices.complexity1') },
    { id: 6, name: t('removalPage.services.complexity2'), price: t('removalPage.prices.complexity2') },
    { id: 7, name: t('removalPage.services.complexity3'), price: t('removalPage.prices.complexity3') },
    { id: 8, name: t('removalPage.services.over10mm1'), price: t('removalPage.prices.over10mm1') },
    { id: 9, name: t('removalPage.services.over10mm2'), price: t('removalPage.prices.over10mm2') },
    { id: 10, name: t('removalPage.services.over10mm3'), price: t('removalPage.prices.over10mm3') },
    { id: 11, name: t('removalPage.services.over10mm4'), price: t('removalPage.prices.over10mm4') },
    { id: 12, name: t('removalPage.services.papilloma'), price: t('removalPage.prices.papilloma') },
    { id: 13, name: t('removalPage.services.wartsFace'), price: t('removalPage.prices.wartsFace') },
    { id: 14, name: t('removalPage.services.wartsPlantar'), price: t('removalPage.prices.wartsPlantar') },
    { id: 15, name: t('removalPage.services.condylomas'), price: t('removalPage.prices.condylomas') },
    { id: 16, name: t('removalPage.services.papillomas10'), price: t('removalPage.prices.papillomas10') },
    { id: 17, name: t('removalPage.services.papillomas20'), price: t('removalPage.prices.papillomas20') },
    { id: 18, name: t('removalPage.services.cryotherapy05'), price: t('removalPage.prices.cryotherapy05') },
    { id: 19, name: t('removalPage.services.cryotherapy06'), price: t('removalPage.prices.cryotherapy06') },
    { id: 20, name: t('removalPage.services.cryotherapy10'), price: t('removalPage.prices.cryotherapy10') },
    { id: 21, name: t('removalPage.services.cryotherapy19'), price: t('removalPage.prices.cryotherapy19') },
    { id: 22, name: t('removalPage.services.anesthesia'), price: t('removalPage.prices.anesthesia') }
  ];

  const toggleService = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleBookAppointment = () => {
    const selectedServiceNames = removalServices
      .filter(service => selectedServices.includes(service.id))
      .map(service => `${service.name} - ${service.price}`);
    
    if (selectedServiceNames.length > 0) {
      onButtonClick(`Запись на удаление: ${selectedServiceNames.join('; ')}`);
    } else {
      onButtonClick('Запись на консультацию по удалению');
    }
  };

  const totalPrice = removalServices
    .filter(service => selectedServices.includes(service.id))
    .reduce((sum, service) => {
      const priceStr = service.price.replace(' руб.', '').replace(/\s/g, '');
      return sum + (parseInt(priceStr) || 0);
    }, 0);

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">🔬</div>
          <h1>{t('removalPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('removalPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('removalPage.welcome')}</h2>
          <p className="subtitle">{t('removalPage.chooseProcedure')}</p>
        </div>

        <div className="services-list-section">
          <div className="services-scroll-container">
            {removalServices.map((service) => (
              <div 
                key={service.id}
                className={`service-item ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                onClick={() => toggleService(service.id)}
              >
                <div className="service-checkbox">
                  {selectedServices.includes(service.id) ? '✓' : ''}
                </div>
                <div className="service-info-full" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span className="service-name-full" style={{ color: 'white' }}>{service.name}</span>
                  {service.price && (
                    <span className="service-price" style={{ color: 'white' }}>{service.price}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedServices.length > 0 && (
          <div className="services-total" style={{ margin: '20px 0', padding: '15px', background: 'rgba(255,255,255,0.1)', borderRadius: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="total-label" style={{ color: 'white' }}>Выбрано процедур:</span>
            <span className="total-count" style={{ background: 'rgba(52,152,219,0.3)', padding: '5px 12px', borderRadius: '20px', color: 'white' }}>{selectedServices.length}</span>
            <span className="total-price" style={{ color: '#2ecc71', fontSize: '18px', fontWeight: '700' }}>{totalPrice} руб.</span>
          </div>
        )}

        <div className="buttons-grid">
          <button 
            className="service-btn book-btn" 
            onClick={handleBookAppointment}
            style={selectedServices.length > 0 ? { background: 'linear-gradient(135deg, rgba(39, 174, 96, 0.9), rgba(46, 204, 113, 0.9))' } : {}}
          >
            <span className="btn-icon">📅</span>
            <span className="btn-text" style={{ color: 'white' }}>
              {selectedServices.length > 0 ? 'Записаться на выбранные процедуры' : 'Записаться на консультацию'}
            </span>
          </button>

          <button 
            className="service-btn back-btn"
            onClick={onBack}
          >
            <span className="btn-icon">←</span>
            <span className="btn-text" style={{ color: 'white' }}>{t('removalPage.services.back')}</span>
          </button>
        </div>
      </main>

      <footer className="footer">
        <p>{t('removalPage.footer.main')}</p>
        <p className="footer-info">{t('removalPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default RemovalPage;